import React, { useState } from 'react'
import Modal from '../common/modal'

export default function MainLayout(props) {
    const [isModalVisible, setIsModalVisible] = useState(true);
    return (
        <main>
            <div className="container-fluid">
                {props.children}
                {/* <div className="row">
                    <div className="col text-center mb-5">
                        <a href="#" className="btn btn-outline-primary btn-rounded waves-effect add-btn float-right ml-auto float-right"
                            data-toggle="modal" data-target="#hello"><i className="fas fa-users" /> Hello Modal</a>
                        <button onClick={() => { window.$('#hello').modal('show') }}> click me </button>
                        <Modal id="hello"
                            iconClass="fas fa-users"
                            title="Hello Title"
                            okAction={() => { alert('closed') }} >
                            Hello world Body
                        </Modal>

                        <a href="revenue-management.html" class="btn btn-outline-primary btn-rounded waves-effect back-btn mr-auto float-left"><i class="fas fa-angle-double-left"></i> Back </a>
                        <h1 className="h1 d-inline-block m-auto">Dashboard</h1>


                    </div>
                </div> */}

            </div>
        </main>
    )
}
